var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRealData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M22.5 1C34.4 1 44 10.6 44 22.5S34.4 44 22.5 44 1.1 34.4 1.1 22.5 10.7 1 22.5 1m0-1C10.1 0 .1 10.1.1 22.5S10.1 45 22.5 45 45 34.9 45 22.5 34.9 0 22.5 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee887a",
    d: "M36.83 31.324c.026 1.131-1.172 1.397-2.067 1.293H9.438c-1.844.07-1.593-2.928.21-2.587h25.888c.696-.017 1.311.598 1.294 1.294zm-26.156-3.737v-13.91c-.027-1.132 1.172-1.398 2.066-1.294h20.238c1.134-.03 1.434 1.16 1.322 2.066v13.138c.024 1.143-1.195 1.393-2.095 1.294H11.968c-.692.012-1.304-.604-1.294-1.294zm2.616-1.322h18.395V14.97H13.29v11.295z"
  })));
}

export default SvgRealData;